// extracted by mini-css-extract-plugin
module.exports = {"scaleDown":"Expand_scaleDown__3iMmR","expand":"Expand_expand__1ZMlM","minus":"Expand_minus__Fdzfl","plus":"Expand_plus__WI3v1"};